export default {
  filters: {
    rainLabel(val) {
      return ['停', '小', '中', '大', '特大'][val]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/history/RainLevelNameMixin.js